import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import SidebarItem from "./SidebarItem";
import ConnectBar from "./ConnectBar";
import ReferralBar from "./ReferralBar";
import Settings from "./Settings";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins, faHome, faUsd, faSackDollar, faXmark, faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import UpgradeModal from "./UpgradeModal";
import { formatCurrency, getRate } from '../utils/currencyUtils';
import feather from 'feather-icons';
import { Link } from "react-router-dom"

function Sidebar({title, isOpen, toggleSidebar, toggleSettingsBar, settingsBar }) {
  const currentPath = window.location.pathname;
  useEffect(() => {
    feather.replace();
  }, []);
  const { user } = useUser();
  const [referralBar, setReferralBar] = useState(false);
  const [connectBar, setConnectBar] = useState(false);
  const toggleReferralBar = () => {
    setReferralBar(!referralBar);
  };
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  useEffect(() => {
    if (window.innerWidth >= 768) {
      toggleSidebar(true);
    }
  }, []);
  const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const [crypto, setCrypto] = useState([]);
    const [fiat, setFiat] = useState([]);
    const [wallet, setWallet] = useState([]);
    const [assetBal, setAssetBal] = useState(0);
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchwallet: true })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setWallet(data.wallet);
        }
      })
      .catch(err => {
        
      })
    }, [user]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
            name: coin.name,
            type: 'crypto',
            symbol: coin.symbol,
            price: Number(coin.quote.USD.price.toFixed(2)),
            amount: 0,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {   
        fetch(`/fiat_list.txt`)
        .then((res) => res.json())
        .then((data) => {
          const wantedCurrencies = {
            AUD: 'Australian Dollar',
            CAD: 'Canadian Dollar',
            CHF: 'Swiss Franc',
            CNY: 'Chinese Yuan',
            EUR: 'Euro',
            GBP: 'British Pound',
            INR: 'Indian Rupee',
            JPY: 'Japanese Yen',
            RUB: 'Russian Ruble',
            USD: 'US Dollar',
            ZAR: 'South African Rand'
          };
          const fiatList = Object.entries(data)
            .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
            .map(([code, value], index) => ({
              id: index + 1,
              symbol: code,
              name: wantedCurrencies[code],
              price: Number(value),
              type: 'fiat',
              logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
              amount: 0,
            }));
          
          setFiat(fiatList);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
      if (!crypto.length && !fiat.length) return;
      const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
      }, {});
      let total = 0;
      let cryptoTotal = 0;
      let fiatTotal = 0;
      const applyWalletBalance = (list) => {
        let categorySum = 0;
        const result = list.map(item => {
          const key = item.name?.trim().toLowerCase();
          const matchedBalance = walletMap[key];
          const amount = matchedBalance || 0;
          const value = amount * item.price;
          categorySum += value;
          return {
            ...item,
            amount: matchedBalance || 0
          };
        });
        return { result, categorySum };
      };
      const { result: cryptoWithBalance, categorySum: cryptoSum } = applyWalletBalance(crypto);
      const { result: fiatWithBalance, categorySum: fiatSum } = applyWalletBalance(fiat);
      cryptoTotal = cryptoSum;
      fiatTotal = fiatSum;
      total = cryptoTotal + fiatTotal;
      const merged = [
        ...cryptoWithBalance,
        ...fiatWithBalance,
      ];
      const sorted = merged.sort((a, b) => {
        if (b.amount > 0 && a.amount === 0) return 1;
        if (a.amount > 0 && b.amount === 0) return -1;
        return a.name.localeCompare(b.name);
      });
      setAssetBal(total);
    }, [crypto, fiat, wallet]);
    const logout = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/logout.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ logout: true})
      })
      .then(response => response.text())
      .then(data => {
        if (data === "success") {
          window.location.href = "login";
        }
      })
      .catch(err => {
        console.error(err)
      }) 
    };
    return (
      <>
        <div className={`col-auto sidebar ${window.innerWidth < 768 ? "mobilesidebar" : ""} ${isOpen ? "active" : ""}`}style={{ display: "block" }}>
          <img src={logo} alt="logo" className="app-logo mb-3" style={{paddingLeft:'16px',paddingRight:'16px'}}/>
          <div className="d-flex align-items-center justify-content-center rounded-circle position-absolute d-block d-md-none" style={{width:'30px',height:'30px', top:'15px',right:'20px',backgroundColor:'#ffffff0d'}} onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>
          </div>
          <div className="py-3 w-100" style={{backgroundColor:'#0a0b0c', paddingLeft:'16px',paddingRight:'16px'}}>
            <p className="text-secondary fw-semibold mb-0" style={{fontSize:'12px'}}>MAIN ACCOUNT BALANCE</p>
            <div className="d-flex align-items-top justify-content-between">
              <div>
                <div className="d-flex align-items-end">
                  <p className="fs-2 fw-semibold text-prime mb-0 lh-1">{formatCurrency(assetBal * rate)}</p>
                  <p className="fs-6 ms-3 text-white fw-semibold mb-0">{user?.currency}</p>
                </div>
                <p className="mb-0 fw-semibold text-white" style={{fontSize:'14px'}}>{formatCurrency(assetBal * rate)} {user?.currency}</p>
              </div>
              <i data-feather="log-out" className="text-prime" style={{cursor:'pointer'}} width="20" onClick={logout}></i>
            </div>  
            <hr/>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Profit (All)</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.savings_gain * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Total Deposits</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.total_deposit * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Total Withdraws</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.total_withdraw * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3">
              <Link to="/deposit" className="py-2 d-flex justify-content-center rounded-pill" style={{border: '2px solid #ff6b35',backgroundColor:'transparent', textDecoration:'none',width:'47%'}}>
                <p className="mb-0 fw-semibold text-prime" style={{fontSize: '12px'}}>DEPOSIT</p>
              </Link>
              <Link to="/withdraw" className="d-flex justify-content-center rounded-pill bg-prime" style={{textDecoration:'none', paddingTop:'10px',paddingBottom:'10px',width:'47%'}}>
                <p className="mb-0 fw-semibold" style={{fontSize: '12px'}}>WITHDRAW</p>
              </Link>
            </div>
          </div>
          <div className="sidebar-navbar" style={{marginTop:'10px',paddingLeft:'16px',paddingRight:'16px'}}>
            <p className="mb-0 fw-bold text-white" style={{fontSize:'14px'}}>Account</p>
            <SidebarItem icon={<i data-feather="home" height="18"></i>} label="Dashboard" isActive={(title === "Dashboard")?true:false} link="/dashboard" />
            <SidebarItem icon={<i data-feather="credit-card" height="18"></i>} label="Deposit" isActive={(title === "Deposit")?true:false} link="/deposit" />
            <SidebarItem icon={<i data-feather="package" height="18"></i>} label="Withdraw" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
            <SidebarItem icon={<i data-feather="send" height="18"></i>} label="Swap" isActive={(title === "Swap")?true:false} link="/transfer" />
            <SidebarItem icon={<i data-feather="grid" height="18"></i>} label="Assets" isActive={(title === "Assets")?true:false} link="/assets" />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>401(k) Retirement</p>
            <SidebarItem icon={<i data-feather="bar-chart" height="18"></i>} label="401k Portfolio" isActive={(title === "401k Portfolio")?true:false} link="/portfolio" />
            <SidebarItem icon={<i data-feather="command" height="18"></i>} label="Contributions" isActive={(title === "Contributions")?true:false} link="/contributions" />
            <SidebarItem icon={<i data-feather="trending-up" height="18"></i>} label="Performance" isActive={(title === "Performance")?true:false} link="/performance" />
            <SidebarItem icon={<i data-feather="grid" height="18"></i>} label="401(k) plans" isActive={(title === "401(k) plans")?true:false} link="/upgradeplan" />
            <SidebarItem icon={<i data-feather="list" height="18"></i>} label="Transactions" isActive={(title === "Transactions")?true:false} link="/transaction" />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>Loan</p>
            <SidebarItem icon={<i data-feather="dollar-sign" height="18"></i>} label="Loan" isActive={(title === "Loan")?true:false} link="/loan" />
            <SidebarItem icon={<i data-feather="target" height="18"></i>} label="Get a Loan" isActive={(title === "Get a Loan")?true:false} link="/getloan" />
            <SidebarItem icon={<i data-feather="list" height="18"></i>} label="Loan History" isActive={(title === "Loan History")?true:false} link="/loanhistory" />
            <SidebarItem icon={<i data-feather="book-open" height="18"></i>} label="Requirement" isActive={(title === "Requirement")?true:false} link="/requirements" />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>Settings</p>
            <SidebarItem icon={<i data-feather="link" height="18"></i>} label="Connect wallet" isActive={(title === "Connect wallet")?true:false} onClick={() => {toggleConnectBar()}}  />
            <SidebarItem icon={<i data-feather="settings" height="18"></i>} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
            {user?.user_type === "adminface" && (
              <SidebarItem icon={<i data-feather="user-check" height="18"></i>} label="Admin" isActive={(title === "Admin")?true:false} />
            )}
          </div>
        </div>
        <div className="bottom-tab">
          <div className="bottom-tab1" style={{width:'78%',height:'55px'}}>
            <Link to="/deposit" className={`rounded-pill d-flex flex-column align-items-center justify-content-center h-100 noLink ${(title === "Deposit")?'active':null}`} style={{cursor:'pointer',width:'25%'}}>
              <FontAwesomeIcon icon={faUsd} style={{fontSize: '20px'}} className="lh-1 mb-1"/>
              <p className="fw-semibold mb-0 lh-1" style={{fontSize:'12px'}}>Deposit</p>
            </Link>
            <Link to="/portfolio" className={`rounded-pill d-flex flex-column align-items-center justify-content-center h-100 noLink ${(title === "401k Portfolio")?'active':null}`} style={{cursor:'pointer',width:'25%'}}>
              <FontAwesomeIcon icon={faSackDollar} style={{fontSize: '20px'}} className="lh-1 mb-1"/>
              <p className="fw-semibold mb-0 lh-1" style={{fontSize:'12px'}}>401(k)</p>
            </Link>
            <Link to="/loan" className={`rounded-pill d-flex flex-column align-items-center justify-content-center h-100 noLink ${(title === "Loan")?'active':null}`} style={{cursor:'pointer',width:'25%'}}>
              <FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '20px'}} className="lh-1 mb-1"/>
              <p className="fw-semibold mb-0 lh-1" style={{fontSize:'12px'}}>Loan</p>
            </Link>
            <Link to="/upgradeplan" className={`rounded-pill d-flex flex-column align-items-center justify-content-center h-100 noLink ${(title === "401(k) plans")?'active':null}`} style={{cursor:'pointer',width:'25%'}}>
              <FontAwesomeIcon icon={faCoins} style={{fontSize: '20px'}} className="lh-1 mb-1"/>
              <p className="fw-semibold mb-0 lh-1" style={{fontSize:'12px'}}>Plans</p>
            </Link>
          </div>
          <div className="bottom-tab2" style={{width:'50px',height:'55px',minWidth:'55px',minHeight:'50px'}}>
            <Link to="/dashboard" className={`rounded-circle d-flex align-items-center justify-content-center w-100 h-100 noLink ${(title === "Dashboard")?'active':null}`} style={{cursor:'pointer'}}>
              <FontAwesomeIcon icon={faHome} style={{fontSize: '22px'}} className="lh-1 mb-1"/>
            </Link>
          </div>
        </div>
        <UpgradeModal UserDetails={user} currentPath={currentPath} />
        <ReferralBar toggleReferralBar={toggleReferralBar} referralBar={referralBar}/>
        <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
        <Settings toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
      </>
    )
}

export default Sidebar